import gsap from 'gsap';
import React from 'react'

interface ProgressBarProps {
  progress?: number;
  totalValue?: number;
  animate?: boolean;
  label?: ({ progress, totalValue }: { progress: number; totalValue: number }) => string;
}

function ProgressBar({ progress = 0, totalValue = 100, animate = false, label }: ProgressBarProps) {
  const progressRef = React.useRef<HTMLDivElement>(null);
  const animation = React.useRef<gsap.core.Tween | null>(null);

  React.useEffect(() => {
    if (animate) {
      animation.current = gsap.to(progressRef.current, {
        width: `${progress}%`,
        duration: 1,
        ease: "power2.inOut",
      });
    } else {
      if (progressRef.current) {
        progressRef.current.style.width = `${progress}%`;
      }
    }
    return () => {
      if (animate) {
        animation.current?.kill();
      }
    };
  }, [animate, progress]);

  return (
    <div className="w-full">
      <div className="text-sm font-medium text-gray-950 pb-2">
        {label ? label({ progress, totalValue }) : null}
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          ref={progressRef}
          className="bg-[#609F81] h-2 rounded-full"
          style={{ width: "0%" }}
        ></div>
      </div>
    </div>
  );
}


export default ProgressBar;
